import { useContext, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import * as Icon from "react-bootstrap-icons";
import { AppStateContext } from "../Context/contextState";

function RemoveBox(props) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { loading, setLoading } = useContext(AppStateContext);

  const handleRemove = async (itemId) => {
    setLoading(true)
    try {
      const response = await fetch(
        
        `https://3dbuilding.parisashahbazi.com/api/projects/${itemId}`,
        // `https://api.ifc.mirzaeei.com/api/projects/${itemId}`,
        // `https://api.mirzaeei.com/api/projects/${itemId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      console.log(response);

      if (response.ok) {
        const data = await response.json();
        
      }
    } catch (err) {
      console.error("Error:", err);
      handleClose();
    } finally {
      handleClose();
    }
  };

  return (
    <>
      <Button
        variant="primary"
        className="btn btn-primary Card-btn"
        onClick={handleShow}
      >
        <Icon.Trash size={"20px"} color="#fff" />
      </Button>

      <Modal show={show} onHide={handleClose} dir="rtl" className="ModalRem">
        <Modal.Header className="Remove-window-header">
          <Modal.Title className="Remove-window-title">
            <Icon.ExclamationTriangleFill size={"25px"} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="Remove-window-body">
          آیا مطمئن هستید که این پروژه حذف شود؟
        </Modal.Body>
        <Modal.Footer>
          <div className="Share-buttons-right">
            <Button
              variant="light"
              className="Close-window-btn"
              onClick={handleClose}
            >
              خیر
            </Button>
            <Button
              variant="success"
              className="Preview-btn me-1"
              onClick={async () => {
                await handleRemove(props.itemId);
                setLoading(true);
                await props.fetchProjects()
              }}
            >
              بله
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default RemoveBox;
